import React from 'react'
import { Alert } from 'react-bootstrap'

function SAlert({type,status,head,message, onClose}) {
  return (
    <Alert variant={type} onClose={onClose} dismissible>
        <Alert.Heading>{head}</Alert.Heading>
        <p>
          {message}
        </p>
    </Alert>
  )
}

export default SAlert